@if (isUploadInProgress()) {
  <div class="video-message video-message--uploading">
    <mat-spinner diameter="24"></mat-spinner>
    <span class="video-message__status-text">{{ 'INBOX.VIDEO.STATUS.UPLOADING' | translate }}</span>
  </div>
}

@if (isProcessing()) {
  <div class="video-message video-message--processing">
    <div class="video-message__status">
      <mat-spinner diameter="24"></mat-spinner>
      <span class="video-message__status-text">{{ processingMessageKey() | translate }}</span>
    </div>
    @if (cancelVisible()) {
      <button mat-button class="video-message__action video-message__action--fade-in" (click)="videoCancel.emit()">{{ 'INBOX.VIDEO.ACTION.CANCEL' | translate }}</button>
    }
  </div>
}

@if (isSending()) {
  <div class="video-message video-message--sending">
    <mat-spinner diameter="24"></mat-spinner>
    <span class="video-message__status-text">{{ 'INBOX.VIDEO.STATUS.SENDING' | translate }}</span>
  </div>
}

@if (isSent()) {
  <div class="video-message video-message--sent">
    @if (videoUrl()) {
      <video
        class="video-message__player"
        controls
        preload="metadata"
      >
        <source [src]="videoUrl()" type="video/mp4">
      </video>
    }
  </div>
}

@if (isError()) {
  <div class="video-message video-message--error">
    <mat-icon class="video-message__error-icon">error_outline</mat-icon>
    <span class="video-message__error-text">{{ displayErrorMessageKey() | translate }}</span>
    <div class="video-message__actions">
      @if (showRetry()) {
        <button mat-button class="video-message__action" (click)="retry.emit()">{{ 'INBOX.VIDEO.ACTION.RETRY' | translate }}</button>
      }
      <button mat-button class="video-message__action" (click)="dismiss.emit()">{{ 'INBOX.VIDEO.ACTION.DISMISS' | translate }}</button>
    </div>
  </div>
}

@if (isUnknownState()) {
  <div class="video-message video-message--error">
    <mat-icon class="video-message__error-icon">error_outline</mat-icon>
    <span class="video-message__error-text">{{ 'INBOX.VIDEO.ERROR.UNKNOWN' | translate }}</span>
    <div class="video-message__actions">
      <button mat-button class="video-message__action" (click)="dismiss.emit()">{{ 'INBOX.VIDEO.ACTION.DISMISS' | translate }}</button>
    </div>
  </div>
}
